import { VStack } from '@bpba/ui-components';
import { StyledSpan } from '../shared/StyledSpan';
import styled from 'styled-components';
import { textAlign, TextAlignProps } from 'styled-system';
import { RetryMessage } from './RetryMessage';

type TemplateProps = {
  children: React.ReactNode;
  title: string;
  message?: string | null;
} & TextAlignProps;

const BaseTemplate = (props: TemplateProps) => {
  return (
    <VStack justifyContent={'center'}>
      <StyledSpan
        color="white"
        lineHeight={['28px']}
        fontSize={['20px']}
        fontWeight={500}
        {...props}
        marginBottom={['15px']}
        justifyContent={'center'}
      >
        <div dangerouslySetInnerHTML={{ __html: props.title }} />
      </StyledSpan>
      {props.message && <RetryMessage msg={props.message} />}
      {props.children}
    </VStack>
  );
};

export const TemplateCanje = styled(BaseTemplate)<TemplateProps>(textAlign);
